module.exports = __webpack_public_path__ + "static/media/open-arrow.3034481b.svg";